import React, { Component } from 'react';
import 'react-dates/initialize';
import {
    DateRangePicker,
} from 'react-dates';

import Icon from 'src/components/icon';

import 'react-dates/lib/css/_datepicker.css';
import './date-range-input.scss';
import moment from 'moment';

const uniqStringId = () => {
    const randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    const uniqid = randLetter + Date.now();

    return uniqid;
};

class DateRangeInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            focusedInput: null,
        };
    }

    render() {
        const { focusedInput } = this.state;
        const { onDatesChange = () => {}, ...props } = this.props;
        return (
            <DateRangePicker
                startDateId={uniqStringId()}
                endDateId={uniqStringId()}
                focusedInput={focusedInput}
                onFocusChange={focusedInput => this.setState({ focusedInput })}
                customArrowIcon={<Icon code="arrow-right" color="#B2BEC3" />}
                onDatesChange={onDatesChange}
                startDatePlaceholderText="Data inicial"
                endDatePlaceholderText="Data final"
                hideKeyboardShortcutsPanel
                displayFormat={() => "DD/MM/YYYY"}
                {...props}
            />
        );
    }

}

export default DateRangeInput;
